// export const api_url = "http://localhost:5000/api/";
// export const api_url = "http://52.66.11.219:80/api/";
// export const api_url = "https://api.smindiagroup.com/api/";
// export const api_url = "https://dev-api.smindiagroup.com/api/";
export const api_url = "https://api.smindia2050.com/api/";
export const img_url = "https://api.smindia2050.com/";

// export const img_url = "http://localhost:5000/";
//  export const img_url = "https://api.smindiagroup.com/api/";
// export const api_url = "https://api.smindiagroup.com/";
// export const img_url = "https://dev-api.smindiagroup.com/api/";

export const web_url = "https://smindia2050.com";
// export const web_url = "http://localhost:3001";
